// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"4838":"33d91445","9412":"37a763b4"}[chunkId] || chunkId) + "." + {"74":"7d7d97fcf6fae0a4","1468":"ffaa376ac78fd65d","4838":"6299817856658795","9412":"c95e6e066e18dfea"}[chunkId] + ".js";
};